import { render, staticRenderFns } from "./AdvancedDeFiCategorization.vue?vue&type=template&id=b5b09eb8&"
import script from "./AdvancedDeFiCategorization.vue?vue&type=script&lang=ts&"
export * from "./AdvancedDeFiCategorization.vue?vue&type=script&lang=ts&"
import style0 from "./AdvancedDeFiCategorization.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports